<template>
  <div class="resultados">
    <div>
      Has respondido correctamente a {{total_preguntas_correctas}}/{{total_preguntas}} preguntas
    </div>
    <div class="end">
      <router-link to="/cuestionario" ><questionnaire-button>{{$t('cambiarRespuestas')}}</questionnaire-button></router-link>
      <br>
      <router-link to="/" @click.native="$questionnaire.clearAllAnswers"><questionnaire-button>{{$t('finalizar')}}</questionnaire-button></router-link>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    answers() {
      return this.$questionnaire.answers
    },
    total_preguntas() {
      return Object.keys(this.answers).length
    },
    total_preguntas_correctas() {
      var contador = 0
      for (let q_id in this.answers) {
        const userAnswers = this.answers[q_id]
        const totalCorrectAnswers = this.$questionnaire.getCorrectAnswers(q_id)
        const userCorrectAnswers = userAnswers.filter(
          x => totalCorrectAnswers.indexOf(x) !== -1
        )
        if (
          userCorrectAnswers.length === userAnswers.length &&
          userCorrectAnswers.length === totalCorrectAnswers.length
        )
          contador++
      }
      return contador
    }
  }
}
</script>

<style scoped lang="scss">
  .resultados {
    text-align: center;
  }
  .end {
    margin: 3em 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Resultados.vue